import { NativeSelect } from "@mui/material";
import { FormizoSchema } from "Components/LabIZO/Formizo";
import { ConditionOperator, CustomFilterValueProps, FieldType, Filterable, TablizoSchema } from "Components/LabIZO/Tablizo";
import _ from "lodash";
import { Accessor } from "static";

const Table: TablizoSchema[] = [
  {
    label: "Date",
    name: "Date",
    filterable: true,
    defaultSort: "desc",
  },
  {
    label: "Day",
    name: "Day",
    filterable: true,
  },
  {
    label: "Time Slot",
    name: "TimeSlot",
    filterable: true,
  },
  {
    label: "Number of NEW customer login to Chatbot",
    name: "NewCustomerLogin",
    filterable: true,
    valueGetter: (row, field, addOns) => {
      let NewCustomerLogin = Accessor.Get(row, "NewCustomerLogin");
      return NewCustomerLogin !== undefined ? NewCustomerLogin : "";
    },
  },
  {
    label: "Number of NEW customer login to Chatbot (Proceed enquiry after login)",
    name: "NewCustomerEnquiry",
    filterable: true,
    valueGetter: (row, field, addOns) => {
      let NewCustomerEnquiry = Accessor.Get(row, "NewCustomerEnquiry");
      return NewCustomerEnquiry !== undefined ? NewCustomerEnquiry : "";
    },
  },
  {
    label: "Max number of concurrent customer",
    name: "MaxConcurrentCustomer",
    filterable: true,
    valueGetter: (row, field, addOns) => {
      let MaxConcurrentCustomer = Accessor.Get(row, "MaxConcurrentCustomer");
      return MaxConcurrentCustomer !== undefined ? MaxConcurrentCustomer : "";
    },
  },
  {
    label: "Number of Conversation",
    name: "NumberOfConversation",
    filterable: true,
    valueGetter: (row, field, addOns) => {
      let NumberOfConversation = Accessor.Get(row, "NumberOfConversation");
      return NumberOfConversation !== undefined ? NumberOfConversation : "";
    },
  },
];

const Info: FormizoSchema[] = [
  {
    label: "ID",
    name: "_id",
    validate: ["required"],
    format: "text",
    readOnly: true,
  },
  {
    label: "SessionID",
    name: "sessionID",
    format: "text",
    readOnly: true,
  },
  {
    label: "Datetime",
    name: "recTime",
    format: "text",
    readOnly: true,
  },
  {
    label: "Grade",
    name: "grade",
    format: "text",
    readOnly: true,
  },
  {
    label: "Reason",
    name: "reason",
    format: "text",
    readOnly: true,
  },
  {
    label: "Irrelevant",
    name: "irrelevant",
    format: "text",
    readOnly: true,
  },
  {
    label: "Incomplete",
    name: "incomplete",
    format: "text",
    readOnly: true,
  },
  {
    label: "Other Answer",
    name: "otherAnswer",
    format: "text",
    readOnly: true,
  },
  {
    label: "Selection",
    name: "selection",
    format: "text",
    readOnly: true,
  },
];

const Filterables: Filterable[] = [
  // {
  //   field: "language",
  //   label: "Language",
  //   type: FieldType.text,
  // },
  // {
  //   field: "FAQ ID",
  //   label: "FAQ_id",
  //   type: FieldType.text,
  // },
];

const Export = [
  {
    label: "Date",
    name: "Date",
  },
  {
    label: "Day",
    name: "Day",
  },
  {
    label: "Time Slot",
    name: "TimeSlot",
  },
  {
    label: "Number of NEW customer login to Chatbot",
    name: "NewCustomerLogin",
  },
  {
    label: "Number of NEW customer login to Chatbot (Proceed enquiry after login)",
    name: "NewCustomerEnquiry",
  },
  {
    label: "Max number of concurrent customer",
    name: "MaxConcurrentCustomer",
  },
  {
    label: "Number of Conversation",
    name: "NumberOfConversation",
  },
];

const AdvFilter: any = [];

const schema: any = {
  Table,
  Info,
  Export,
  // AdvFilter,
  // Filterables,
};

export default schema;
